import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _capitalize from "lodash/capitalize";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.map.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState, useContext } from 'react';
import classnames from 'classnames';
import Utility from "../../Utility/Utility";
import { ToggleButton } from "../../Button/ToggleButton/ToggleButton";
import { Container } from "../../Container/Container/Container";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Text } from "../../Text/Text/Text";
import { ThemeContext } from "../../../context/theme.context";
import styles from "./IAFFAQSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var faqAnswerTypes = ['fullWidthAnswer', 'multiRowsAnswer'];
export var faqAlign = ['left', 'center'];
export var IAFFaqSlice = function IAFFaqSlice(_ref) {
  var _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'center' : _ref$align,
    _ref$heading = _ref.heading,
    heading = _ref$heading === void 0 ? {
      ariaLevel: 2,
      text: '',
      typog: 'headline3',
      variant: 'default'
    } : _ref$heading,
    faqData = _ref.faqData,
    _ref$questionTypog = _ref.questionTypog,
    questionTypog = _ref$questionTypog === void 0 ? 'bodycopyExtraLarge' : _ref$questionTypog;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var theme = useContext(ThemeContext);
  var renderQuestions = function renderQuestions() {
    return faqData === null || faqData === void 0 ? void 0 : faqData.map(function (data, key) {
      var questionWithoutTags = typeof data.question === 'string' ? Utility.stripTags(data.question) : '';
      return /*#__PURE__*/_jsxs("div", {
        className: styles.qaContainer,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.questionContainer,
          children: /*#__PURE__*/_jsx(ToggleButton, _objectSpread(_objectSpread({
            accessibilityLabel: show === key ? "collapse ".concat(questionWithoutTags, " button") : "expand ".concat(questionWithoutTags, " button"),
            "aria-expanded": show === key,
            iconPosition: "right",
            iconSize: "16px",
            onPress: function onPress() {
              return setShow(show === key ? null : key);
            },
            styleType: show === key ? 'quaternary' : 'tertiary',
            className: classnames(styles.questionToggleButtonButton, {
              [styles.questionToggleButtonButtonDarkBg]: theme === 'darkBackground'
            }),
            flexEnd: true,
            childClassName: styles.childTextFaq
          }, data.buttonAttributes), {}, {
            children: /*#__PURE__*/_jsx(Text, {
              className: styles.question,
              typog: questionTypog,
              children: data.question
            })
          }))
        }), /*#__PURE__*/_jsx("div", {
          className: show === key ? styles.showAnswers : styles.hideAnswers,
          children: (data === null || data === void 0 ? void 0 : data.answerType) && data.answers && renderAnswers(data.answerType, data.answers)
        }), /*#__PURE__*/_jsx("hr", {
          className: styles.lineBreak
        })]
      }, key);
    });
  };
  var renderMultiRow = function renderMultiRow(answer) {
    var _ref2 = answer || {},
      rows = _ref2.rows;
    return /*#__PURE__*/_jsx("div", {
      className: styles.multiRowsAnswerContainer,
      children: rows === null || rows === void 0 ? void 0 : rows.map(function (row, key) {
        return /*#__PURE__*/_jsx(Text, {
          richText: true,
          typog: "bodycopy",
          "data-e2e-name": "tout_body_text",
          className: row.textSize === 'small' ? styles.smallText : '',
          children: row.text
        }, key);
      })
    });
  };
  var renderAnswers = function renderAnswers(answerType, answers) {
    switch (answerType) {
      case 'multiRowsAnswer':
        return renderMultiRow(answers === null || answers === void 0 ? void 0 : answers.multiRowsAnswer);
      case 'fullWidthAnswer':
        return /*#__PURE__*/_jsx(Text, {
          richText: true,
          typog: 'bodycopy',
          className: styles.fullWidthAnswer,
          children: answers === null || answers === void 0 ? void 0 : answers.fullWidthAnswer
        });
      default:
        return null;
    }
  };
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.wrapper,
      children: [align && (heading === null || heading === void 0 ? void 0 : heading.text) && /*#__PURE__*/_jsx("div", {
        className: classnames(styles.header, styles["headerAlign".concat(_capitalize(align))]),
        children: (heading === null || heading === void 0 ? void 0 : heading.text) && heading.ariaLevel && heading.typog && heading.variant && /*#__PURE__*/_jsx(HeadingText, {
          align: align,
          ariaLevel: heading.ariaLevel,
          typog: heading.typog,
          variant: heading.variant,
          children: heading.text
        }, "heading")
      }), /*#__PURE__*/_jsx("div", {
        className: styles.questionsContainer,
        children: faqData && renderQuestions()
      })]
    })
  });
};